import { useTranslation } from 'react-i18next';

import { EllipsisIcon, ImageIcon, Share2Icon, SparklesIcon } from 'lucide-react';

import { Button } from '@/components/new-ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/new-ui/dropdown-menu';

type DropdownMediaButtonsProps = {
  type: 'estate' | 'project';
  canWriteMedia?: boolean;
  isThumbnailDisabled?: boolean;
  onShare?: () => void;
  onChooseThumbnail?: () => void;
  onClickImageRendering?: () => void;
};

// Collapsed version of the extra media actions for narrow screens
export const DropdownMediaButtons = ({
  type = 'estate',
  canWriteMedia = true,
  isThumbnailDisabled,
  onShare,
  onChooseThumbnail,
  onClickImageRendering,
}: DropdownMediaButtonsProps) => {
  const { t } = useTranslation();

  const showThumbnail = Boolean(canWriteMedia && onChooseThumbnail);
  const showRendering = type === 'estate' && Boolean(canWriteMedia && onClickImageRendering);
  const showShare = type === 'estate' && Boolean(canWriteMedia && onShare);
  // Download lives in the select mode, so a reader can end up with an empty menu
  if (!showThumbnail && !showRendering && !showShare) return null;

  return (
    <div className="md:hidden">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" aria-label={t('actions')}>
            <EllipsisIcon />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {showThumbnail ? (
            <DropdownMenuItem disabled={isThumbnailDisabled} onClick={onChooseThumbnail}>
              <ImageIcon className="mr-2 h-4 w-4" />
              {t('chose-thumbnail')}
            </DropdownMenuItem>
          ) : null}
          {showRendering ? (
            <DropdownMenuItem onClick={onClickImageRendering}>
              <SparklesIcon className="mr-2 h-4 w-4" />
              {t('aiImageRendering')}
            </DropdownMenuItem>
          ) : null}
          {showShare ? (
            <DropdownMenuItem onClick={onShare}>
              <Share2Icon className="mr-2 h-4 w-4" />
              {t('share')}
            </DropdownMenuItem>
          ) : null}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
